import React from 'react';
import classNames from 'classnames';

function getOpacityFromProgress(progress: number): string {
  if (progress <= 10) {
    return 'opacity-25';
  }
  if (progress > 10 && progress < 20) {
    return 'opacity-30';
  }
  if (progress > 20 && progress < 30) {
    return 'opacity-40';
  }
  if (progress >= 30 && progress < 40) {
    return 'opacity-50';
  }
  if (progress >= 40 && progress < 50) {
    return 'opacity-60';
  }
  if (progress >= 50 && progress < 60) {
    return 'opacity-70';
  }
  if (progress >= 60 && progress < 70) {
    return 'opacity-80';
  }
  if (progress >= 70 && progress < 80) {
    return 'opacity-90';
  }
  if (progress >= 80 && progress < 90) {
    return 'opacity-95';
  }
  return 'opacity-100';
}

function getColorFromProgress(progress: number, failed: boolean, gradient: boolean): string[] {
  if (failed) {
    return ['bg-red-600'];
  }

  switch (progress) {
    case 100:
      return ['bg-green-500'];
    default:
      return ['bg-primary-600', gradient ? getOpacityFromProgress(progress) : ''];
  }
}

type Props = {
  progress: number | undefined;
  failed?: boolean | undefined;
  done?: boolean;
  gradient?: boolean;
  getColor?: (progress: number, failed: boolean, gradient: boolean) => string[];
};

function ProgressBar({
  progress = 10,
  failed = false,
  done = false,
  gradient = true,
  getColor = getColorFromProgress,
}: Props) {
  progress = Math.max(progress, 10);

  if (done || failed) {
    progress = 100;
  }

  return (
    <div className="h-2 w-full space-y-3 rounded-full bg-gray-200">
      <div
        style={{ width: `${progress}%`, transition: 'width 0.3s ease-in-out' }}
        className={classNames(['h-full', 'rounded-full', ...getColor(progress, failed, gradient)])}
      />
    </div>
  );
}

export default ProgressBar;
